import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const rtsScoreRequestSchema = z.object({
  jobDescription: z.string().min(10, "Job description must be at least 10 characters"),
});

export const rtsScoreResponseSchema = z.object({
  score: z.number().min(0).max(100),
  verdict: z.enum(["needs_improvement", "decent_match", "strong_match"]),
  matchedKeywords: z.array(z.string()),
  missingKeywords: z.array(z.string()),
  explanation: z.string(),
});

export class RtsScoreRequestDto extends createZodDto(rtsScoreRequestSchema) {}
export class RtsScoreResponseDto extends createZodDto(rtsScoreResponseSchema) {}